import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error (benign in React)
// This error occurs with Radix UI components and is not harmful
if (typeof window !== 'undefined') {
  const origError = window.console.error;
  window.console.error = (...args) => {
    if (args[0]?.includes?.('ResizeObserver') || 
        (typeof args[0] === 'string' && args[0].includes('ResizeObserver'))) {
      return;
    }
    origError.apply(window.console, args);
  };

  // Override error event
  window.addEventListener('error', (e) => {
    if (e.message?.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  }, true);

  // Patch ResizeObserver to debounce
  const RO = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends RO {
    constructor(callback) {
      super((entries, observer) => {
        requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
